import { take } from 'rxjs';
/* eslint-disable @angular-eslint/component-selector */
/* eslint-disable @typescript-eslint/no-inferrable-types */
import {
  Component,
  OnInit,
  Input,
  OnChanges,
  ViewChild,
  AfterViewChecked,
  signal,
  computed,
} from '@angular/core';
import moment from 'moment';
import { CustomerModel, DataListModel } from '@kanzi-apes/kanzi-models';
import { KanziTraceLineChartModel } from '../../models/kanzi-trace-line-chart.model';
import { KanziRestClientService } from '@kanzi-apes/kanzi-rest-api';
import { EnvironmentService } from '@kanzi-apes/kanzi-utils';
import { EChartsOption, RegisteredSeriesOption } from 'echarts';
import { current } from 'immer';

declare type Values<T> = T[keyof T];
declare type TSeries = Values<RegisteredSeriesOption>;
type ISeries = TSeries[] | undefined;
@Component({
    selector: 'lib-kanzi-traces-line-chart',
    templateUrl: './kanzi-traces-line-chart.component.html',
    styleUrls: ['./kanzi-traces-line-chart.component.scss'],
    standalone: false
})
export class KanziTracesLineChartComponent implements OnChanges {
  @Input() title: string = '';
  @Input() customer!: CustomerModel | null;
  @Input() statusOption: string = '';
  @Input() statusSecondOption: string = '';
  @Input() statusOptionName: string = '';
  @Input() statusSecondOptionName: string = '';
  @Input() headerName: string = '';
  // @ViewChild(DxChartComponent, { static: false }) chart!: DxChartComponent;
  private kongUrl = this.envService.environment!.kongApi;
  private path = 'inventory/traces/';
  tracesByMonth: KanziTraceLineChartModel[] = [];
  monthList = moment().localeData().months();

  public series = signal<ISeries>([]);
  public xSeries = signal<string[]>(['Impresos', 'Salidas']);
  public xAxisData = signal<string[]>([]); //Bodegas
  public optionsCharts = signal<EChartsOption>({
    legend: {},
    tooltip: {},
    toolbox: {
      feature: {
        dataView: {},
      },
    },
    xAxis: {
      type: 'category',
      boundaryGap: false,
      data: [],
      axisLine: { onZero: true },
      splitLine: { show: false },
      splitArea: { show: false },
    },
    yAxis: {},
    series: [],
  });
  public updateOptions = computed<EChartsOption>(() => ({
    legend: {
      data: this.xSeries(),
      left: '10%',
    },
    xAxis: {
      data: this.xAxisData(),
      axisLine: { onZero: true },
      splitLine: { show: false },
      splitArea: { show: false },
    },
    series: this.series(),
  }));

  constructor(
    private restClient: KanziRestClientService,
    private envService: EnvironmentService
  ) {}

  ngOnChanges() {
    const today = new Date();
    if (this.statusOption && this.statusSecondOption) {
      for (let i = 12; i >= 0; i -= 1) {
        let month = today.getMonth() - i;
        let year = today.getFullYear();

        const d = new Date(year, month, 1);
        this.tracesByMonth.push({
          month: `${this.monthList[d.getMonth()]} - ${d.getFullYear()}`,
          year: d.getFullYear(),
          minDate: moment(d).startOf('month').format('YYYY-MM-DD'),
          maxDate: moment(d).endOf('month').format('YYYY-MM-DD'),
          data: 0,
          dataSecond: 0,
        });
      }
      this.xAxisData.set(this.tracesByMonth.map((t) => t.month));
      this.processTracesData(this.tracesByMonth);
    }
  }

  processTracesData(dataMonth: KanziTraceLineChartModel[]) {
    dataMonth.forEach((data, i) => {
      const printed$ = this.restClient.get<DataListModel>(
        this.kongUrl.concat(this.path),
        {
          page: 1,
          page_size: 1,
          customer_id: this.customer ? this.customer.id : null,
          created_min: data.minDate,
          created_max: data.maxDate,
          action: this.statusOption,
        }
      );

      const verified$ = this.restClient.get<DataListModel>(
        this.kongUrl.concat(this.path),
        {
          page: 1,
          page_size: 1,
          customer_id: this.customer ? this.customer.id : null,
          created_min: data.minDate,
          created_max: data.maxDate,
          action: this.statusSecondOption,
        }
      );

      printed$.subscribe((results: DataListModel) => {
        this.tracesByMonth[i] = {
          ...this.tracesByMonth[i],
          data: results.count,
        };
        this.xSeries.update((current) => {
          current[0] = this.statusOption;
          return current;
        });
        this.series.update((current) => {
          if (current) {
            current[0] = {
              name: this.statusOption,
              type: 'line',
              stack: 'Total',
              data: this.tracesByMonth.map((t) => t.data),
            };
          }

          return current;
        });
      });

      verified$.subscribe((results: DataListModel) => {
        this.tracesByMonth[i] = {
          ...this.tracesByMonth[i],
          dataSecond: results.count,
        };

        this.xSeries.update((current) => {
          current[1] = this.statusSecondOption;
          return current;
        });
        this.series.update((current) => {
          if (current) {
            current[1] = {
              name: this.statusSecondOption,
              type: 'line',
              stack: 'Total',
              data: this.tracesByMonth.map((t) => t.dataSecond),
            };
          }
          return current;
        });
      });
    });
  }
}
